export default __webpack_public_path__ + "static/media/jacksonhole.8e8c144f.jpg";